import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import $ from 'jquery';
import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import useIsAIChatOpenInPhone from 'llm/chat-library/useIsAIChatOpenInPhone';
import {ZENDESK_GUIDE_URL} from 'nav/ZendeskConstants';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

export function initHelpContainer(): void {
  if (!BenchlingConfig.ENABLE_IN_APP_SUPPORT) {
    const $helpContainerNode = $('.helpContainer-mount');
    renderToDOM(<HelpButton />, $helpContainerNode[0]);
  }
}

export function HelpButton(): JSX.Element {
  const isAIChatOpenInPhone = useIsAIChatOpenInPhone();
  // When in-app support is disabled, we should use CUSTOMER_ADMIN_EMAIL for contact
  // Otherwise, fallback to the help URL (Zendesk Guide or Support Site URL)
  const getHelpUrl = (): string => {
    if (!BenchlingConfig.ENABLE_IN_APP_SUPPORT && BenchlingConfig.CUSTOMER_ADMIN_EMAIL) {
      return `mailto:${BenchlingConfig.CUSTOMER_ADMIN_EMAIL}`;
    }
    return BenchlingConfig.ENABLE_ZENDESK_GUIDE ? ZENDESK_GUIDE_URL : BenchlingConfig.SUPPORT_SITE_URL;
  };

  return (
    <div className={classNames('helpContainer', css(isAIChatOpenInPhone ? styles.inAIChat : null))}>
      <a href={getHelpUrl()} target="_blank" rel="noopener noreferrer">
        <span className="helpContainer-icon">
          <BenchlingIcon icon="question" />
        </span>
      </a>
    </div>
  );
}

const styles = StyleSheet.create({
  inAIChat: {
    bottom: '165px',
    right: '10px',
  },
});
